export const COURSE_TYPE_ONLINE = 4;
export const PARAMS_TO_REMOVE = [
  "m",
  "pid",
  "from",
  "hideregistration",
  "prid",
];
